export default "__VITE_ASSET__CHDztKAW__"